import styled from 'styled-components'
import { BaseGrid, BaseFlexContainer } from '~/globalStyles'

export const TextContainer = styled(BaseGrid)`
  gap: 0.25rem;
`

export const LeftSideColumn = styled(BaseGrid)`
  gap: 1rem;
`

export const ActionsContainer = styled(BaseFlexContainer)`
  gap: 2rem;
`
